import React, { FC } from "react";

import Input from "../../Input/Input";
import { TCheckboxProps } from "./Checkbox.interface";
import { useCheckbox } from "../useCheckbox";

const Checkbox: FC<TCheckboxProps> = ({ checked, onChange, ...inputProps }) => {
  const [isChecked, handleChange] = useCheckbox(checked, onChange);

  return (
    <Input
      type="checkbox"
      checked={!!isChecked}
      onChange={handleChange}
      data-testid="checkbox-input"
      {...inputProps}
    />
  );
};

export default Checkbox;
